import React, {ComponentType} from "react";
import AlertDialog from "./index";
import {IProps, IContainerProps, IHandlers, classPrefix} from './types';

/**
* Gets the interface types as array of strings so we don't need hand code them each time (and reduces chance for mistakes).
*/
import {keys} from 'ts-transformer-keys';
import {hot} from "react-hot-loader";
import ReactUtilsService from "app/services/reactUtils.service";

const NS = 'AlertDialogContainer';


const propsKeys: string[] = keys<IProps>();
const containerPropsKeys: string[] = keys<IContainerProps>();

const ThemeWrap = function(all: IProps & IContainerProps) {

  const props: IProps = ReactUtilsService.getObjectByKeys(all, propsKeys) as IProps;
  const containerProps: IContainerProps = ReactUtilsService.getObjectByKeys(all, containerPropsKeys) as IContainerProps;

 /**
   * Passes all base props from container to component
   */
  // @ts-ignore
  containerPropsKeys.forEach(key => props[key] = containerProps[key]);

  /**
   * Handlers used to modify app state (via a service) from within the module's container.
   * Similar to redux mapDispatchToProps.
   */
     const handlers: IHandlers = {
      onAlertDialogClose(): void {
        return containerProps.onAlertDialogClose();
      }
    }

  return ReactUtilsService.containerWrap(
    <AlertDialog {...props} {...handlers} />, classPrefix
  );
}

/**
 * Returns properties needed for rendering react2angular
 */
export const R2AAlertDialog: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(ThemeWrap) as ComponentType<unknown>,
  [...containerPropsKeys] as never[]
];
